import { withErrorBoundary } from 'app/components/error-boundary';
import type { NavigationScreen } from 'app/types/navigation';
import { BorrowerNextScreenBody } from './borrower-next-screen-body';
import { useBorrowerNextScreen } from './use-borrower-next-screen';

const BorrowerNextScreenComponent: NavigationScreen<'borrowerNext'> = ({ navigation }) => {
  const screenState = useBorrowerNextScreen(navigation);

  return <BorrowerNextScreenBody {...screenState} />;
};

export const BorrowerNextScreen: NavigationScreen<'borrowerNext'> = withErrorBoundary(BorrowerNextScreenComponent);
